var _defs, _path, _path2, _path3, _rect, _rect2, _path4, _path5, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Pool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "V7aocVoazWaKZTpHzcBwxb",
    x1: 16.096,
    x2: 32.004,
    y1: 12.466,
    y2: 56.172,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 129",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec52b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V7aocVoazWaKZTpHzcBwxc",
    x1: 17.107,
    x2: 32.998,
    y1: 14.869,
    y2: 58.53,
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442\\u043D\\u043E\\u0439 \\u0437\\u0430\\u043B 2",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V7aocVoazWaKZTpHzcBwxa",
    x1: 31,
    x2: 37,
    y1: 330,
    y2: 330,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 180",
    gradientTransform: "matrix(1 0 0 -1 0 340)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92a3b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#a3b5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#aec2d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046,
    stopColor: "#b2c6d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V7aocVoazWaKZTpHzcBwxd",
    x1: 23,
    x2: 29,
    xlinkHref: "#V7aocVoazWaKZTpHzcBwxa"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V7aocVoazWaKZTpHzcBwxe",
    x1: 24,
    x2: 24,
    y1: 21.334,
    y2: 15.435,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 51",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#28a2f3",
    stopOpacity: 0.036
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#249ef0",
    stopOpacity: 0.136
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#1d97ec",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#148ee6",
    stopOpacity: 0.527
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#0882de",
    stopOpacity: 0.814
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V7aocVoazWaKZTpHzcBwxf",
    x1: 32,
    x2: 32,
    y1: 21.334,
    y2: 15.435,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 50",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#28a2f3",
    stopOpacity: 0.037
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#249ef0",
    stopOpacity: 0.139
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#1d97ec",
    stopOpacity: 0.306
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#138de5",
    stopOpacity: 0.537
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#0781de",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V7aocVoazWaKZTpHzcBwxb)",
    d: "M36.5,12h-25a2,2,0,0,0-1.976,1.69125l-4.5,28A2,2,0,0,0,7,44H41a2,2,0,0,0,1.976-2.30875l-4.5-28A2,2,0,0,0,36.5,12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0370c8",
    d: "M7.51267,40.84131l4.00035-26A1,1,0,0,1,12.5,14h23a1,1,0,0,1,.98768.84132l3.99965,26A1,1,0,0,1,39.5,42H8.5A1,1,0,0,1,7.51267,40.84131Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V7aocVoazWaKZTpHzcBwxc)",
    d: "M9.51267,40.84131l3.50035-24A1,1,0,0,1,14,16H34a1,1,0,0,1,.98768.84132l3.49965,24A1,1,0,0,1,37.5,42h-27A1,1,0,0,1,9.51267,40.84131Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 24,
    y: 10,
    fill: "#64717c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 24,
    y: 14,
    fill: "#64717c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V7aocVoazWaKZTpHzcBwxa)",
    d: "M31,16V7a3,3,0,0,1,6,0,1,1,0,0,1-2,0,1,1,0,0,0-2,0v9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#V7aocVoazWaKZTpHzcBwxd)",
    d: "M23,16V7a3,3,0,0,1,6,0,1,1,0,0,1-2,0,1,1,0,0,0-2,0v9Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4,
    x: 23,
    y: 16,
    fill: "url(#V7aocVoazWaKZTpHzcBwxe)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4,
    x: 31,
    y: 16,
    fill: "url(#V7aocVoazWaKZTpHzcBwxf)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    x: 31.5,
    y: 13.5,
    opacity: 0.05,
    transform: "rotate(90 33.5 14)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 0.5,
    x: 31.25,
    y: 13.75,
    opacity: 0.07,
    transform: "rotate(90 33.25 14)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    x: 20.5,
    y: 13.5,
    opacity: 0.05,
    transform: "rotate(-90 22.5 14)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 0.5,
    x: 20.75,
    y: 13.75,
    opacity: 0.07,
    transform: "rotate(-90 22.75 14)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Pool);
export default __webpack_public_path__ + "static/media/icons8-pool.1c146e8da691a311337a98b104d9a75e.svg";
export { ForwardRef as ReactComponent };